// extracted by mini-css-extract-plugin
module.exports = {"item":"item--36r1o","reverse":"reverse--Mq4bl","textWrap":"textWrap--bI5yz","describe":"describe--1Q2ke","imageWrap":"imageWrap--jNuGg"};